// extracted by mini-css-extract-plugin
export default {"nav-button":"NavButton_nav-button__gCk1O","active":"NavButton_active__nU53K"};